var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var insuranceEstimationCollection = require('./insuranceEstimationCollection');

/**
 * Data Behavior hooked up to the insurance estimation cache.
 * @class InsuranceEstimationDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: insuranceEstimationCollection
});
